import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'strong'
})

export class StrongPipe implements PipeTransform {

  transform(value: any, text: string): any {
    const specialCharacters = '/[.*+?|()\[\]{}\\$^]/g';
    const escapedText = text.replace(specialCharacters, '\\$&');
    const tokenized = escapedText.split(' ');
    const regex = new RegExp(tokenized.join('|'), 'gmi');

    return value.replace(regex, (match, item) => {
      return `<b class="highlight">${match}</b>`;
    });
  }
}
